// lib/magic.js
import { Magic } from "magic-sdk"

export const magic =
  typeof window !== "undefined" &&
  new Magic(import.meta.env.VITE_MAGIC_PUBLIC_PUBLISHABLE_KEY)
